import { useContext } from 'react';
import { Panel } from '../../../../layouts';
import { ROType } from '../../../../types/enums';
import { RetailOrderContext } from '../context/RetailOrderContext';
import ScheduleCountertopDates from "./ScheduleCountertopDates";
import ScheduleCabinetDates from "./ScheduleCabinetDates";
import SchedulePlumbingDates from "./SchedulePlumbingDates";

export default function ScheduleDatesPanel() {

	const { order } = useContext(RetailOrderContext);

	const isCabinetOrder = order.details.roTypeID === ROType.CabinetInstallOrder;
	const isPlumbingOrder = order.details.roTypeID === ROType.Plumbing;
	const isCountertopOrder = !isCabinetOrder && !isPlumbingOrder;

	return (
		<Panel header={'Dates'}>
			{
				isCountertopOrder &&
				<ScheduleCountertopDates />
			}
			{
				isCabinetOrder &&
				<ScheduleCabinetDates />
			}
			{
				isPlumbingOrder &&
				<SchedulePlumbingDates />
			}
		</Panel>
	);
}
